<!-- Progress bar 
<mat-progress-bar *ngIf="progressBar == true" [color]="'accent'" [mode]="'indeterminate'" [value]="10"
                  [bufferValue]="10"></mat-progress-bar> -->

<!-- Spinner -->
<div class="content-mat-spinner" *ngIf="spinner == true">
  <mat-spinner color="accent"></mat-spinner>
</div>
